import "../styles/ol.css";
import "../styles/ol-ext.css";
import "../styles/FG-copy.css";

import Attribution from 'ol/control/Attribution';
import Bar from 'ol-ext/control/Bar';
import BingMaps from 'ol/source/BingMaps';
import FeatureSelect from 'ol/interaction/Select';
import FullScreen from 'ol/control/FullScreen';
import GeoJSON from 'ol/format/GeoJSON';
import Graticule from 'ol-ext/control/Graticule';
import ImageLayer from 'ol/layer/Image';
import ImageWMS from 'ol/source/ImageWMS';
import LayerGroup from 'ol/layer/Group';
import LayerSwitcher from 'ol-ext/control/LayerSwitcher';
import Map from 'ol/Map';
import RasterSource from 'ol/source/Raster';
import TextButton from 'ol-ext/control/TextButton';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import Toggle from 'ol-ext/control/Toggle';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import View from 'ol/View';
import WMSCapabilities from 'ol/format/WMSCapabilities';
import WMTS, {optionsFromCapabilities} from 'ol/source/WMTS';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
import XYZ from 'ol/source/XYZ';
import proj4 from 'proj4';
import {Circle, Fill, Stroke, Style, Text} from 'ol/style';
import {Control, ScaleLine, defaults as defaultControls} from 'ol/control';
import {fromLonLat} from 'ol/proj';
import {getPointResolution, get as getProjection} from 'ol/proj';
import {getTopLeft, getWidth} from 'ol/extent';
import {register} from 'ol/proj/proj4';
import {transformExtent} from 'ol/proj';
import ColorScaleControl from '../FG/FGColorScaleControl';
import ColorScaleLegendControl from '../FG/FGColorScaleLegendControl';
import SearchFeature from '../FG/FGSearchFeature';
import PrintScaleControl from '../FG/FGPrintScaleControl';
import MousePosition from 'ol/control/MousePosition';
import {createStringXY} from 'ol/coordinate';
//import HistogramControl from "./FGHistogramControl";
//import ClickInfoControl from "./FGClickInfoControl";


proj4.defs(
  'EPSG:26912',
  '+proj=utm +zone=12 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'
);
register(proj4);
const proj26912 = getProjection('EPSG:26912');
proj26912.setExtent([196765.3486, 2749459.8086, 803234.6514, 8799482.7282]);
const projectExtent = proj26912.getExtent();

const grat = new Graticule({
  step: 40,
  stepCoord: 2,
  projection: 'EPSG:26912',
});

const labelStyle = new Style({
  text: new Text({
    font: '12px Calibri,sans-serif',
    rotation: 0,
    textAlign: 'left',
    overflow: true,
    fill: new Fill({
      color: '#000',
    }),
    stroke: new Stroke({
      color: '#fff',
      width: 3,
    }),
  }),
});
const wellStyle = new Style({
  image: new Circle({
    radius: 10,
    fill: new Fill({color: 'rgba(255, 0, 0, 0.1)'}),
    stroke: new Stroke({color: 'blue', width: 1}),
  }),
});
const style = [wellStyle, labelStyle];


//var scaleLine = new ScaleLine({});
const scaleLine = new ScaleLine({bar: true, text: true, minWidth: 125});
const view = new View({
  // center: fromLonLat([54.6, -111.9]),
  center: [409154.432,5614524.872],
  projection: proj26912,
   zoom: 14,
});

//grid

function toggleGraticuleLines(on) {
  let style;
  if (on) {
    style = new Style({
      text: new Text({
        font: '12px Calibri,sans-serif',
        rotation: 0,
        textAlign: 'left',
        overflow: true,
        fill: new Fill({
          color: '#000',
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 3,
        }),
      }),
      stroke: new Stroke({
        color: '#000',
        width: 1,
      }),
      fill: new Fill({
        color: '#fff',
      }),
    });
  } else {
    style = new Style({
      text: new Text({
        font: '12px Calibri,sans-serif',
        rotation: 0,
        textAlign: 'left',
        overflow: true,
        fill: new Fill({
          color: '#000',
        }),
        stroke: new Stroke({
          color: '#fff',
          width: 3,
        }),
      }),
      fill: new Fill({
        color: '#000',
      }),
    });
  }
  grat.setStyle(style);
  map.render();
}
const mousePositionControl = new MousePosition({
  coordinateFormat: createStringXY(4),
  projection: 'EPSG:26912',
  // comment the following two lines to have the mouse position
  // be placed within the map.
  //className: 'custom-mouse-position',
  //target: document.getElementById('mouse-position'),
});
const map = new Map({
  target: 'map',
  units: 'm',
  controls: defaultControls().extend([new FullScreen(), scaleLine, mousePositionControl]),
  layers: [
    new TileLayer({
      visible: true,
      title: 'Bing',
      preload: Infinity,
      source: new BingMaps({
        key: '82o22Jd9KBSXdi7KOw9F~-ljDB0Kkf0oF-Egpwvb9_w~Aqsa-2Is6gI2fOr88_Kgqe8RC041lQaheYQt9ISHnZ2L4jpJkBerWGqwZ2t31CRV',
        imagerySet: 'Aerial',
         // use maxZoom 19 to see stretched tiles instead of the BingMaps
        // "no photos at this zoom level" tiles
        maxZoom: 20,
      }),
    }),
    new TileLayer({
      title: "Elevation", 
      visible: false,
        source: new TileWMS({
          url: 'https://wms.focusedgeo.ca/geoserver/wms',
          crossOrigin: '',
            params: {
              'VERSION': '1.1.1',
              //tiled: true,
              'STYLES': '',
              'LAYERS': 'Bassano:Bassano_DEM',
            },
        }),     
    }),
    new TileLayer({
      title: "NDVI", 
      visible: false,
        source: new TileWMS({
          url: 'https://wms.focusedgeo.ca/geoserver/wms',
          crossOrigin: '',
            params: {
              'VERSION': '1.1.1',
              //tiled: true,
              'STYLES': '',
              'LAYERS': 'Bassano:Bassano_NDVI_COG',
                                 },
        }),     
    }),
    new TileLayer({
      title: "OrthoImage", 
      visible: true,
        source: new TileWMS({
          url: 'https://wms.focusedgeo.ca/geoserver/wms',
          crossOrigin: '',
            params: {
              'VERSION': '1.1.1',
              //tiled: true,
              'STYLES': '',
              'LAYERS': 'Bassano:Bassano_NCI_COG',
                                 },
        }),     
    }),
    new TileLayer({
      title: "EM31", 
      visible: true,
        source: new TileWMS({
          url: 'https://wms.focusedgeo.ca/geoserver/wms',
          crossOrigin: '',
            params: {
              'VERSION': '1.1.1',
              //tiled: true,
              'STYLES': '',
              'LAYERS': 'Bassano:Bassano_EM31',
                                 },
        }),     
    }),
    new TileLayer({
      title: "EM31-inphase", 
      visible: false,
        source: new TileWMS({
          url: 'https://wms.focusedgeo.ca/geoserver/wms',
          crossOrigin: '',
            params: {
              'VERSION': '1.1.1',
              //tiled: true,
              'STYLES': '',
              'LAYERS': 'Bassano:Bassano_EM31ip',
                                 },
        }),     
    }),
 
    // new TileLayer({
    //   title: "Contours", 
    //   visible: true,
    //     source: new TileWMS({
    //       url: 'https://wms.focusedgeo.ca/geoserver/wms',
    //       crossOrigin: '',
    //         params: {
    //           'VERSION': '1.1.1',
    //           tiled: true,
    //           'STYLES': '',
    //           'LAYERS': '029_Westx:12-23-073-12w6_EM31_contours',
    //         },
    //     }),     
    // }),
   
    new TileLayer({
      title: 'Pipelines',
      visible: false,
      source: new TileWMS({
        url: 'https://wms.focusedgeo.ca/geoserver/FocusedGeo/wms',
        crossOrigin: '',
        params: {
          'VERSION': '1.1.1',
          tiled: true,
          'STYLES': '',
          'LAYERS': 'FocusedGeo:Pipelines_GCS_NAD83',
          tilesOrigin: -120.051391601563 + ',' + 48.9456367492676,
        },
      }),
    }),

    
  ],
  view: view,
});

// map.addControl(grat);

const layerSwitcher = new LayerSwitcher();
map.addControl(layerSwitcher);


const print = new PrintScaleControl();

/* function exportGeotiff() {
  const params = {
    SERVICE: 'WMS',
    VERSION: '1.3.0',
    REQUEST: 'GetMap',
    FORMAT: 'image/geotiff',
    TRANSPARENT: true,
  };
  const layer_name = feature_select.getFeatures().getArray()[0].getProperties()[
    'id'
  ];

  const layer = findLayerByName(layer_name, map.getLayers());
  Object.assign(params, layer.getSource().getParams());
  const tiff_url = layer
    .getSource()
    .getRequestUrl_(layer.getExtent(), [512, 512], 1, proj26912, params);
  window.open(tiff_url);
} */

const sub1 = new Bar({
  toggleOne: true,
  controls: [
     print,
    // new Toggle({
    //   html: 'Grid',
    //   active: true,
    //   visible:false,
    //     onToggle: function () {
    //     toggleGraticuleLines(this.getActive());
    //   },
    // }),
    /* NOT WORKING at the moment
		new TextButton({
			html: "Export GEOTIFF (site which is annotated) ",
			active: false,
			handleClick: exportGeotiff
		})
    */
  ],
});

const mainbar = new Bar({
  controls: [
    new Toggle({
      html: 'Tools',
      // First level nested control bar
      bar: sub1,
      onToggle: function () {},
    }),
  ],
});
map.addControl(mainbar);
function newFunction() {
  return 11;
}

/*
console.log(layer_list_31[0].getSource().getImage());
console.log(layer_list_31[0].getSource().getUrl());*/
